class PurchaseOrderProductSearchController extends AbstractController
	autoScopeInject: false

	@register()
	@inject 'ProductRepository',
		'PurchaseOrderFormatService'
		'MessageTerminal'
		'parseBool'
		'BACKEND_PRODUCT_ENTITY_TYPE'

	initialize: ->
		@filter ?= {}
		@events = @MessageTerminal.events.PURCHASE_ORDER
		@productsSearch = []

	searchProducts: (search) ->
		query = @ProductRepository.createQuery()
		query.sortBy('name', 'ASC')
		query.setPagination(0, @ProductRepository.pageSize)

		query.with(
			'stock_values',
			'product_data',
			'product_variants',
			'product_variants>stock_values',
			'product_variants>product_data',
		)

		excludeFromOrderingSuggestionQuery = query.criteria('exclude_from_ordering_suggestion', '=', false)
		excludeFromOrderingSuggestionQuery.or('exclude_from_ordering_suggestion', 'IS', 'NULL')

		query.criteria('entity_type', '!=', @BACKEND_PRODUCT_ENTITY_TYPE.BUNDLE)

		if !_.isEmpty(search)
			criteria = @ProductRepository.addSkuCriteria(query, search)
			criteria
				.or('name', 'LIKE', search)
				.or('supplier_reference_id', 'LIKE', search)
				.or('product_variants.product_variant_name', 'LIKE', search)
				.or('product_variants.supplier_reference_id', 'LIKE', search)

		if !_.isEmpty @filter.supplierId
			supplierCriteria = query.criteria 'supplier_id', '=', @filter.supplierId
			supplierCriteria.or 'product_variants.supplier_id', '=', @filter.supplierId

		@ProductRepository
			.findByQuery(query, false, true)
			.then (response) =>
				@productsSearch = @filterProductSearch(response.data, @filter.stockLocationId)

	filterProductSearch: (products, stockLocationId) ->
		return _.filter(
			products,
			(product) =>
				stockValue = _.find(
					product.stock_values,
					(value) -> value.stock_location_id == stockLocationId
				)

				return !stockValue || @parseBool(stockValue.is_included_in_ordering_suggestion_report)
		)

	addProduct: (item) ->
		@productsSearch = _.without @productsSearch, item
		manualProduct = @PurchaseOrderFormatService.productToReport(item, @filter.stockLocationId, @priceRegionId)

		@addAdditionalProduct manualProduct

	addAdditionalProduct: (products) ->
		@MessageTerminal.publish @events.ADD_ITEM, products, true
